import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  toggleApplicationRulesModal: `${NAMESPACE}_TOGGLE_APPLICATION_RULES_MODAL`,
  openApplicationRulesModal: `${NAMESPACE}_OPEN_APPLICATION_RULES_MODAL`,
};

export const actionCreators = {
  toggleApplicationRulesModal: payload => ({ type: actions.toggleApplicationRulesModal, payload }),
  openApplicationRulesModal: payload => ({ type: actions.openApplicationRulesModal, payload }),
};

export default {
  actions,
  actionCreators,
};
